export default __webpack_public_path__ + "static/media/980.6b584661.png";